export default class Configuration {
  static get EnvConfig() {
    return {
      VUE_APP_API_HOST: 'https://api.e6golf.com',
      VUE_APP_V3_API_HOST: 'https://v3.e6api.com',
      VUE_APP_UPLOADER_API_HOST: 'https://course-uploader-otulxb2g4q-uc.a.run.app',
      VUE_APP_ASSETS_HOST: 'https://e6golf-assets.imgix.net/',
      VUE_APP_TINYMCE_KEY: 'yagc19m1d0ed1j9yzh21vfkciphtunm949fktas9giwp8978',
      VUE_APP_GOOGLE_MAPS_KEY: 'AIzaSyAKc3JZvXdd37enLl31KD7WaGH076H0YIU',
      VUE_APP_FIREBASE_KEY: 'AIzaSyBuGRHcLqnzhIV1w_C0rHqrXZyK7z1u4T0',
      VUE_APP_GCP_STORAGE_BUCKET: 'gs://tachyon-assets',
      VUE_APP_GCP_APEX_STORAGE_BUCKET: 'gs://e6apex-assets',
      VUE_APP_SITE_ENV: 'production',
      VUE_APP_DISCOURSE_HASH_KEY: '2c77cbd2-5fab-4fe9-bc86-a18b51c0ce43',
      envKey2: '$ENV_KEY_2',
    };
  }

  static value(key) {
    // If the key does not exist in the EnvConfig object of the class, return null
    if (!this.EnvConfig.hasOwnProperty(key)) {
      console.error(
        `Configuration: There is no key named "${key}". Please add it in Configuration class.`
      );
      return;
    }

    // Get the value
    const value = this.EnvConfig[key];

    // If the value is null, return
    if (!value) {
      console.error(`Configuration: Value for "${key}" is not defined`);
      return;
    }

    if (!value.startsWith('$VUE_APP_')) {
      // value was already replaced, it seems we are in production (containerized).
      return value;
    }

    // value was not replaced, it seems we are in development.
    const envName = value.substr(1); // Remove $ and get current value from process.env
    const envValue = process.env[envName];

    if (!envValue) {
      console.error(`Configuration: Environment variable "${envName}" is not defined`);
      return;
    }

    return envValue;
  }
}
